/**
 * CMNAV Inline Variant Price
 * ==========================
 * Mirrors the main product price into a compact element near the variant
 * selector so the customer can see the price update without scrolling.
 *
 * The element starts hidden (display:none in HTML) and is only revealed
 * after the customer physically clicks/taps a variant option. The initial
 * auto-select on page load is ignored.
 */
(function () {
  'use strict';

  var el  = document.querySelector('[data-cmnav-variant-price]');
  var src = document.querySelector('[data-product-pricing]');
  if (!el || !src) return;

  /* ---- Cache child elements ---- */
  var currentEl = el.querySelector('[data-cmnav-variant-current]');
  var compareEl = el.querySelector('[data-cmnav-variant-compare]');
  var savingsEl = el.querySelector('[data-cmnav-variant-savings]');

  /* ---- Parse variant data once ---- */
  var variants = [];
  var jsonEl = document.querySelector('[data-cmnav-variants-json]');
  if (jsonEl) {
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { /* noop */ }
  }

  var active = false; /* becomes true after the first real user click */

  /* ---- Sync: copy price from the main pricing area into our element ---- */
  function sync() {
    if (!active) return;

    /* 1. Mirror the formatted current-price text */
    var srcPrice = src.querySelector('[data-price]');
    if (srcPrice && currentEl) {
      currentEl.textContent = srcPrice.textContent.trim();
    }

    /* 2. Mirror compare-at price and its visibility */
    var srcCC = src.querySelector('[data-price-compare-container]');
    var srcCp = src.querySelector('[data-price-compare]');
    var onSale = srcCC && srcCC.classList.contains('visible');

    if (srcCp && compareEl) {
      compareEl.textContent = srcCp.textContent.trim();
      compareEl.style.display = onSale ? '' : 'none';
    }

    /* 3. Calculate savings % from raw variant data (format-safe) */
    var varSel = document.querySelector('variant-selection');
    if (varSel && savingsEl) {
      var vid = varSel.getAttribute('variant');
      if (vid && vid !== 'not-selected') {
        var v = null;
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === vid) { v = variants[i]; break; }
        }
        if (v && v.compare_at_price && v.compare_at_price > v.price) {
          var pct = Math.round(
            (v.compare_at_price - v.price) / v.compare_at_price * 100
          );
          savingsEl.textContent = 'Save ' + pct + '%';
          savingsEl.style.display = '';
        } else {
          savingsEl.style.display = 'none';
        }
      }
    }
  }

  /* ---- Debounced sync for the MutationObserver ---- */
  var timer;
  function debouncedSync() {
    clearTimeout(timer);
    timer = setTimeout(sync, 60);
  }

  /* ---- Activate: reveal the box and start keeping it in sync ---- */
  function activate() {
    if (active) return;
    active = true;

    /* Small delay so the theme JS has time to update the main price first */
    setTimeout(function () {
      sync();
      el.style.display = '';
    }, 120);
  }

  /* ---- Listen for real user clicks on variant option buttons/inputs ---- */
  var optSel = document.querySelector('options-selection');
  if (optSel) {
    optSel.addEventListener('click', activate);
  }
  /* Also cover native <select> dropdowns (used in "select" option style) */
  var variantSelect = document.querySelector('.variant-selection__variants');
  if (variantSelect && variantSelect.tagName === 'SELECT') {
    variantSelect.addEventListener('change', activate);
  }

  /* ---- Once active, keep syncing when the theme updates prices ---- */
  new MutationObserver(debouncedSync).observe(src, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();
